export default {
    numeroPassaporte: 'Pasaporte o identidad',
    nome: 'Nombre',
    nomeCompleto: 'Nombre Completo',
    nacionalidade: 'Nacionalidad',
    nascimento: 'Fecha de Nacimiento',
    email: 'Correo electrónico',
    telefone: 'Teléfono',
    informarContatoEmergencia: '¿Informar contacto de emergencia?',
    informarRestricoesDadosSaude: '¿Informar restricciones y datos de salud?',
    restriçõesDadosSaude: 'Restricciones y datos de salud',
    menoresIdade: 'Para los niños menores de 14 años, la cobertura por muerte accidental se limitará al reembolso de los gastos funerarios.',
    autorizacao: `Autorizo el uso de mis datos personales para la emisión del Seguro de Aventura, y declaro que estoy consciente y he sido informado por el promotor del evento sobre los riesgos involucrados en la práctica de actividades de turismo y deportes de aventura.`
}